import React, { Fragment, useState } from "react";
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Label,
  Row,
  Input,
} from "reactstrap";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { H3, Breadcrumbs, Btn } from "../../../AbstractElements";
import { postDataWithToken } from "../../../Utils/restUtils";
import { addModule } from "../../../CommonURL";
import Transparentspinner from "../../Common/loader/Transparentspinner";

const ModulesAdd = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    setLoading(true);
    const postRequest = {
      name: data.name,
      // code: data.code,
      description: data.description,
    };
    try {
      const response = await postDataWithToken(addModule, postRequest);
      
      if (response?.status === 200) {
        if (response?.data?.status === true) {
          toast.success(response?.data?.message || "Module added successfully");
          navigate(`${process.env.PUBLIC_URL}/configuration/modules`);
        } else {
          const errorMessage = Array.isArray(response?.data?.message)
            ? response.data.message.join(", ")
            : response?.data?.message || "Failed to add module";
          toast.error(errorMessage);
        }
      } else {
        toast.error("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Error adding module:", error);

      const errorMessage = Array.isArray(error?.response?.data?.message)
    ? error.response.data.message.join(", ")
    : error?.response?.data?.message ||
      "Something went wrong. Please try again.";

  toast.error(errorMessage);
} finally {
  setLoading(false);
}
  };

  const handleCancel = () => {
    navigate(`${process.env.PUBLIC_URL}/configuration/modules`);
  };

  return (
    <Fragment>
      {loading && <Transparentspinner />}

      <Breadcrumbs
        mainTitle="Add Module"
        parent="Configuration"
        title="Add Module"
      />

      <Card>
        <CardHeader className="pb-0">
          <H3>Add Module</H3>
        </CardHeader>
        <CardBody>
          <Form
            className="needs-validation"
            noValidate
            onSubmit={handleSubmit(onSubmit)}
          >
            <Row className="g-3">
              <Col md="6">
                <FormGroup>
                  <Label className="form-label" for="name">
                    Name <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.name ? "is-invalid" : ""}`}
                    id="name"
                    type="text"
                    placeholder="Enter module name"
                    {...register("name", {
                      required: "Name is required",
                    })}
                  />
                  {errors.name && (
                    <span className="text-danger small">
                      {errors.name.message}
                    </span>
                  )}
                </FormGroup>
              </Col>

              {/* <Col md="6">
                <FormGroup>
                  <Label className="form-label" for="code">
                    Code <span className="text-danger">*</span>
                  </Label>
                  <input
                    className={`form-control ${errors.code ? "is-invalid" : ""}`}
                    id="code"
                    type="text"
                    placeholder="Enter module code"
                    {...register("code", {
                      required: "Code is required",
                    })}
                  />
                  {errors.code && (
                    <span className="text-danger small">
                      {errors.code.message}
                    </span>
                  )}
                </FormGroup>
              </Col> */}

              <Col md="6">
                <FormGroup>
                  <Label className="form-label" for="description">
                    Description <span className="text-danger">*</span>
                  </Label>
                  <textarea
                    className={`form-control ${
                      errors.description ? "is-invalid" : ""
                    }`}
                    id="description"
                    rows="4"
                    placeholder="Enter module description"
                    {...register("description", {
                      required: "Description is required",
                    })}
                  />
                  {errors.description && (
                    <span className="text-danger small">
                      {errors.description.message}
                    </span>
                  )}
                </FormGroup>
              </Col>
            </Row>

            <div className="d-flex gap-2 mt-4">
              <Btn
                attrBtn={{
                  color: "primary",
                  type: "submit",
                  disabled: loading,
                }}
              >
                Submit Form 
              </Btn>
              
            </div>
          </Form>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default ModulesAdd;
